import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from 'src/app/shared/services';

export const authGuard: CanActivateFn = (_, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isUserLogIn()) {
    router.navigate(['login'], { queryParams: { redirectTo: state.url } });
    return false;
  }

  return true;
};
